import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const EditTutorLayer = () => {
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const location = useLocation();
  const tutorToEdit = location.state?.tutor;

  const [formState, setFormState] = useState({
    tutor_id: "",
    name: "",
    email: "",
    phone: "",
    // roll_no: "",
    address: "",
    gender: "",
    // admission_Date: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);

  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedCourseCategory, setSelectedCourseCategory] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [token, setToken] = useState("");
  const [savedDepartmentName, setSavedDepartmentName] = useState("");
  const [courseCategories, setCourseCategories] = useState("");
  const [courses, setCourses] = useState([]);
  const [isEmailTouched, setIsEmailTouched] = useState(false);
  const [batches, setBatches] = useState([]);
  const [isNameTouched, setIsNameTouched] = useState(false);
  const [isMobileTouched, setIsMobileTouched] = useState(false);
  // snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const file = input.target.files[0];

      // Allowed image types
      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "image/gif",
      ];

      if (!allowedTypes.includes(file.type)) {
        setSnackbarMessage(
          "Invalid file format! Please upload an image (PNG, JPG, JPEG, GIF)."
        );
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        return; // Stop further execution
      }

      // If valid image, read and preview it
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (tutorToEdit) {
      // console.log("tutor to edit : ", tutorToEdit);

      setFormState({
        name: tutorToEdit?.name,
        email: tutorToEdit?.email,
        phone: tutorToEdit?.phone,
        address: tutorToEdit?.address,
        gender: tutorToEdit?.gender,
        tutor_id: tutorToEdit?.tutor_id,
      });
      setImagePreview(tutorToEdit.profile_url);
      setSelectedDepartment(tutorToEdit?.department?._id);
      setSavedDepartmentName(tutorToEdit?.department?.department_name);
      setLoading(false); // Stop loading after setting form state
    } else {
      setError("No tutor data found.");
      setLoading(false);
    }
  }, [tutorToEdit]);

  useEffect(() => {
    // const token1 = localStorage.getItem("token");
    const token1 = localStorage.getItem("token");
    setToken(token1);
    if (!token1) {
      // console.log("Access required");
      return;
    }
    fetchdepartment();
  }, []);

  const fetchdepartment = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDepartments(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return; // Prevent multiple submissions

    if (formState.name && formState.name.length < 2) {
      setError(true);
      return;
    }

    if (formState.phone.length < 8 || formState.phone.length > 15) {
      setError(true);
      return;
    }

    setLoading(true); // Start loading state
    try {
      // const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      // Create a FormData object
      const formData = new FormData();

      // Append each field from formState to the FormData object
      formData.append("name", formState?.name);
      formData.append("email", formState?.email);
      formData.append("phone", formState?.phone);
      formData.append("address", formState?.address);
      formData.append("gender", formState?.gender);

      // Append selectedDepartment if required
      formData.append("selectedDepartment", selectedDepartment);

      const imageInput = document.querySelector("#student-image");
      if (imageInput && imageInput.files[0]) {
        formData.append("image", imageInput.files[0]);
      }

      // Send the formData with a PUT request
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/update-tutor/${tutorToEdit._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // Ensure the content type is set correctly
          },
        }
      );

      if (response.status && response.status === 200) {
        // If response is successful, navigate to the tutor list
        setLoading(false);
        setSnackbarMessage("Updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/tutor-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false); // Stop loading state
      if (err.response && err.response.status === 409) {
        // console.log("409 error detected");
        setSnackbarMessage(
          "This Email ID is already exists. Please check and update accordingly."
        );
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else if (err.response && err.response.status === 402) {
        setSnackbarMessage("Please fill out all required fields..");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to update. Please try again later.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    }
  };

  const handleCancel = () => {
    navigate("/tutor-list");
  };

  return (
    <div className="row gy-4" style={styles.cardContent(loading)}>
      <div className="col-lg-4">
        <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
          <div className="pb-24 ms-16 mb-24 me-16  mt-20">
            <div className="text-center border border-top-0 border-start-0 border-end-0">
              <img
                src={
                  imagePreview || "assets/images/user-grid/user-grid-img14.png"
                }
                alt=""
                className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover"
              />
              <h6 className="mb-0 mt-16">{formState.name}</h6>
              <span className="text-secondary-light mb-16">
                {formState.email}
              </span>
            </div>
            <div className="mt-24">
              <h6 className="text-xl mb-16">Personal Info</h6>
              <ul>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Tutor ID
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.tutor_id}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Full Name
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.name}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Email
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.email}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Phone Number
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.phone}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Address
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.address}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Gender
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.gender}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Department
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {savedDepartmentName}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-8">
        <div className="card h-100">
          <div className="card-body p-24">
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="pills-tab"
              role="tablist"
            >
              {/* <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24 active"
                  id="pills-edit-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-edit-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-edit-profile"
                  aria-selected="true"
                >
                  Edit Profile
                </button>
              </li> */}
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-edit-profile"
                role="tabpanel"
                aria-labelledby="pills-edit-profile-tab"
                tabIndex={0}
              >
                <h6 className="text-md text-primary-light mb-16">
                  Profile Image
                </h6>
                {/* Upload Image Start */}
                <div className="mb-24 mt-16">
                  <div className="avatar-upload">
                    <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                      {/* File input hidden using CSS */}
                      <input
                        type="file"
                        id="student-image"
                        accept="image/*"
                        className="d-none" // This hides the file input
                        onChange={readURL}
                      />
                      <label
                        htmlFor="student-image" // Bind label to file input
                        className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-20 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                      >
                        <Icon icon="solar:camera-outline" className="icon" />
                      </label>
                    </div>
                    <div className="avatar-preview">
                      <div
                        id="imagePreview"
                        style={{
                          backgroundImage: `url(${
                            imagePreview ||
                            "assets/images/user-grid/user-grid-img14.png"
                          })`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* Upload Image End */}
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Full Name
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="name"
                          name="name"
                          value={formState.name}
                          onChange={(e) => {
                            const regex = /^[A-Za-z\s]*$/; // Allow alphabets and spaces only
                            const value = e.target.value;

                            if (value === "" || value.trim() !== "") {
                              if (regex.test(value)) {
                                handleInputChange(e); // Update state only if valid
                              }
                            }
                          }}
                          onBlur={() => {
                            setIsNameTouched(true); // Mark field as touched when focus is lost
                          }}
                          placeholder="Enter full name"
                          required
                        />
                        {isNameTouched && (
                          <>
                            {formState.name && formState.name.length < 2 && (
                              <small className="text-danger-600">
                                Name must be at least 2 characters long
                              </small>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Email <span className="text-danger-600">*</span>
                        </label>
                        <input
                          required
                          type="email"
                          className="form-control radius-8"
                          id="email"
                          value={formState.email}
                          onChange={(e) => {
                            const value = e.target.value;
                            handleInputChange(e); // Update form state
                          }}
                          onBlur={() => setIsEmailTouched(true)} // Mark field as touched
                          placeholder="Enter email address"
                        />
                        {/* {isEmailTouched && (
                          <>
                            {!formState.email && (
                              <small className="text-danger-600">
                                Email is required
                              </small>
                            )}
                            {formState.email &&
                              !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                                formState.email
                              ) && (
                                <small className="text-danger-600">
                                  Invalid email address
                                </small>
                              )}
                          </>
                        )} */}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="phone"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Contact
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="phone"
                          name="phone"
                          value={formState.phone}
                          onChange={(e) => {
                            const regex = /^[0-9]*$/; // Allow numbers only
                            const value = e.target.value;

                            if (
                              (regex.test(value) || value === "") &&
                              value.length <= 15 // Enforce max length
                            ) {
                              handleInputChange(e); // Update state only if valid
                            }
                          }}
                          onBlur={() => {
                            setIsMobileTouched(true); // Mark field as touched when focus is lost
                            if (
                              formState.phone.length < 8 ||
                              formState.phone.length > 15
                            ) {
                              setError(
                                "Contact number must be between 8 and 15 digits."
                              );
                            } else {
                              setError(""); // Clear error if valid
                            }
                          }}
                          placeholder="Enter contact number"
                          maxLength={15} // Ensure no more than 15 characters
                          required
                        />
                        {/* {isMobileTouched && !formState.phone && (
                          <small className="text-danger-600">
                            Contact number is required
                          </small>
                        )} */}
                        {isMobileTouched && (
                          <>
                            {formState.phone &&
                              (formState.phone.length < 8 ||
                                formState.phone.length > 15) && (
                                <small className="text-danger-600">
                                  Contact number must be between 8 and 15
                                  digits.
                                </small>
                              )}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="address"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Address
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="address"
                          name="address"
                          value={formState.address}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || value.trim() !== "") {
                              handleInputChange(e); // Update state only if valid
                            }
                          }}
                          placeholder="Enter address (optional)"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="gender"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Gender
                          <span className="text-danger-600">*</span>
                        </label>
                        <select
                          id="gender"
                          name="gender"
                          value={formState.gender}
                          onChange={handleInputChange}
                          className="form-control radius-8"
                          required
                        >
                          <option value="" disabled>
                            Select Gender
                          </option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="depart"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Department
                          <span className="text-danger-600">*</span>
                        </label>
                        <select
                          className="form-control radius-8 form-select"
                          id="depart"
                          value={selectedDepartment || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            setSelectedDepartment(selectedValue || "");
                          }}
                        >
                          <option value="" disabled>
                            Select Department
                          </option>
                          {departments.map((department) => (
                            <option key={department._id} value={department._id}>
                              {department.department_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="button"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      // onClick={handleSubmit}
                    >
                      {loading && (
                        <div
                          className="loader-container"
                          style={styles.loaderContainer}
                        >
                          <CircularProgress />
                        </div>
                      )}
                      Save
                    </button>
                  </div>
                </form>
              </div>
              <div
                className="tab-pane fade"
                id="pills-notification"
                role="tabpanel"
                aria-labelledby="pills-notification-tab"
                tabIndex={0}
              >
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="companzNew"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Company News
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="companzNew"
                    />
                  </div>
                </div>
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="pushNotifcation"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Push Notification
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="pushNotifcation"
                      defaultChecked=""
                    />
                  </div>
                </div>
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="weeklyLetters"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Weekly News Letters
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="weeklyLetters"
                      defaultChecked=""
                    />
                  </div>
                </div>
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="meetUp"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Meetups Near you
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="meetUp"
                    />
                  </div>
                </div>
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="orderNotification"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Orders Notifications
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="orderNotification"
                      defaultChecked=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditTutorLayer;
